export var version = "3.12.0";
//# sourceMappingURL=version.js.map